<div class="section-header" mat-dialog-title>
    <mat-icon class="section-icon">bar_chart</mat-icon>
    <span class="section-title">{{ 'ai.resourceStatistics' | transloco }}</span>
    <button mat-icon-button class="close-button" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>

<div mat-dialog-content class="dialog-content">
    <div class="resource-dashboard">
        <!-- Bar Chart Card -->
        <div class="chart-card">
            <div class="chart-wrapper bar-chart">
                <ngx-charts-bar-vertical
                    [scheme]="colorScheme"
                    [showXAxisLabel]="false"
                    [showYAxisLabel]="true"
                    [xAxis]="false"
                    [yAxis]="true"
                    [legend]="true"
                    [barPadding]="24"
                    [showDataLabel]="true"
                    [roundEdges]="false"
                    [results]="resourceStatistics"
                    [legendTitle]="'Resource'">
                </ngx-charts-bar-vertical>
            </div>
        </div>

        <!-- Pie Chart Card -->
        <div class="chart-card">
            <div class="chart-wrapper pie-chart">
                <ngx-charts-advanced-pie-chart
                    [scheme]="colorScheme"
                    [results]="dataStoragePercent"
                    [gradient]="false"
                    [animations]="false"
                    [tooltipDisabled]="true"
                    [percentageFormatting]="formatPercentStorageValue"
                    [label]="totalStorageLabel"
                    [valueFormatting]="formatStorageValue">
                </ngx-charts-advanced-pie-chart>
            </div>

            @if (requireAccountUpgrade) {
                <div class="upgrade-banner">
                    <div class="upgrade-text">
                        <mat-icon>warning</mat-icon>
                        <span>{{ 'general.maxStorage' | transloco }}</span>
                    </div>
                    <button mat-raised-button (click)="upgrade()" color="primary">
                        <mat-icon>rocket_launch</mat-icon>
                        {{ 'ai.upgrade' | transloco }}
                    </button>
                </div>
            }
        </div>
    </div>
</div>
